import React, { useState } from 'react'
import InputGroup from '../../EmailSubscriptionCenter/SignIn/InputGroup.jsx'
import FormNotification from '../../SelfService/FormNotification.jsx'
import {
  FORM_NAME_LOGIN_FORM,
  FORM_NAME_VERIFY_PHONE_NUMBER,
} from '../Helpers/LoginHelper.js'

function CapturePhoneNumber({ handleDisplayChange, existingPhoneNumber }) {
  const [formErrorFlag, setFormErrorFlag] = useState(false)
  const formErrorMessage =
    'The phone number you entered is not valid. Please check the number and try again.'
  const [formValidation, setFormValidation] = useState({
    'new-phone-number': {
      error: false,
    },
  })
  const [updatePhoneNumber, setUpdatePhoneNumber] =
    useState(!existingPhoneNumber)
  const [newPhoneNumber, setNewPhoneNumber] = useState('')
  const [choice, setChoice] = useState('existing-phone-number')

  const onChoiceChange = (event) => {
    setChoice(event.target.value)
    setUpdatePhoneNumber(event.target.value === 'provide-new-phone-number')
  }

  const onNextClicked = () => {
    if (updatePhoneNumber) {
      if (!newPhoneNumber || newPhoneNumber.replace(/\D/g, '').length !== 10) {
        const _formValidation = { ...formValidation }
        _formValidation['new-phone-number'].error = true
        setFormValidation(_formValidation)
        setFormErrorFlag(true)
      } else {
        setFormErrorFlag(false)
        handleDisplayChange(FORM_NAME_VERIFY_PHONE_NUMBER, {
          phoneNumber: newPhoneNumber,
          updatePhoneNumber: true,
        })
      }
    } else if (choice === 'existing-phone-number') {
      handleDisplayChange(FORM_NAME_VERIFY_PHONE_NUMBER, {
        phoneNumber: existingPhoneNumber,
        updatePhoneNumber: false,
      })
    }
  }

  const handlePhoneNumberInputChange = (event) => {
    const digits = event.target.value.replace(/\D/g, '').slice(0, 10)
    let formatted = digits
    if (digits.length > 0) {
      formatted = digits.slice(0, 3)
      if (digits.length >= 4) {
        formatted += '.' + digits.slice(3, 6)
      }
      if (digits.length >= 7) {
        formatted += '.' + digits.slice(6, 10)
      }
    }
    setNewPhoneNumber(formatted)
  }

  const onCancelledClicked = () => {
    handleDisplayChange(FORM_NAME_LOGIN_FORM)
  }

  return (
    <div className="u-sizeFull u-lg-size1of2 u-marginBottom6gu Content">
      <h2 className="u-marginBottom2gu u-marginTop0">
        {existingPhoneNumber ? 'Confirm Phone Number' : 'Provide Phone Number'}
      </h2>
      <p className="u-marginBottom3gu">
        To protect your information from the growing risk of cyberattacks, we
        are now employing multi-factor authentication.
        <br />
        <br />
        {existingPhoneNumber
          ? 'Confirming your phone number, or providing a new number, '
          : 'Providing a new number '}
        will ensure you maintain access to important fund data and personal
        sales contact information.
      </p>
      {formErrorFlag && (
        <FormNotification content={formErrorMessage} isHtml={true} />
      )}

      {existingPhoneNumber && (
        <div className="Radio u-flexCol">
          <input
            onChange={onChoiceChange}
            className="Radio-button u-marginLeft0"
            id="existing-phone-number"
            type="radio"
            value="existing-phone-number"
            name="phone-number-radio"
            checked={choice === 'existing-phone-number'}
          />
          <label
            htmlFor="existing-phone-number"
            className="Radio-label u-inlineBlock u-textSecondary u-marginBottom2gu u-marginLeft0"
          >
            {`XXX.XXX.${existingPhoneNumber.slice(-4)}`}
          </label>
          <input
            onChange={onChoiceChange}
            className="Radio-button u-marginLeft0"
            id="provide-new-phone-number"
            type="radio"
            value="provide-new-phone-number"
            name="phone-number-radio"
            checked={choice === 'provide-new-phone-number'}
          />
          <label
            htmlFor="provide-new-phone-number"
            className="Radio-label u-inlineBlock u-textSecondary u-marginBottom2gu u-marginLeft0"
          >
            Provide a new phone number.
          </label>
        </div>
      )}
      {updatePhoneNumber && (
        <InputGroup
          handleInputChange={handlePhoneNumberInputChange}
          formValidation={formValidation}
          fieldName="new-phone-number"
          fieldId="new-phone-number"
          placeholder="_ _ _ . _ _ _ . _ _ _ _"
          maskedValue={newPhoneNumber}
        />
      )}
      <div className="u-flex">
        <div className="u-flex">
          <button
            onClick={onNextClicked}
            className="Button Button--primary  Button--block u-marginRight5gu u-textNoTransform u-flex1of2"
          >
            Next
          </button>
          <button
            onClick={onCancelledClicked}
            className="Button Button--tertiary Button--block u-textNoTransform u-flex1of2"
          >
            Cancel
          </button>
        </div>
      </div>
      <p className="u-marginTop5gu">
        Need help? Contact a Columbia Threadneedle representative at{' '}
        <a aria-label="800. 2 4 8. 2 8 2 8" href="tel: 8002482828">
          800.248.2828.
        </a>
      </p>
    </div>
  )
}

export default CapturePhoneNumber
